import React from 'react'
import { CommentsContext } from './commentsContext'

export const useCommentsContext = () => React.useContext(CommentsContext)
